import { useGetManyReference, useRecordContext, useRecordFromLocation } from 'react-admin'

import type { EventRecord } from '../../data/source'

/** Every event of the scale `scaleRecordId` (newest first); undefined until loaded or without a scale. */
export const useScaleEvents = (scaleRecordId: unknown): EventRecord[] | undefined => {
  const { data } = useGetManyReference<EventRecord>(
    'scale_events',
    {
      target: 'scaleRecordId',
      id: String(scaleRecordId),
      pagination: { page: 1, perPage: 1000 },
      sort: { field: 'startTime', order: 'DESC' },
    },
    { enabled: typeof scaleRecordId === 'string' },
  )
  return data
}

/**
 * The event being edited, or a new one's starting values: on the create page
 * these come with the router state rather than the record context.
 */
export const useEventRecord = (): Partial<EventRecord> | undefined => {
  const fromLocation = useRecordFromLocation()
  return useRecordContext<Partial<EventRecord>>() ?? (fromLocation as Partial<EventRecord> | undefined)
}
